import {useCallback} from 'react'

import {useMappedState} from 'redux-react-hook'

function useUserLoginStatus () {
  const mapState = useCallback(
    state => ({
      loggedIn: state?.common?.loggedIn
    }),
    []
  )

  const {loggedIn = undefined} = useMappedState(mapState)
  return loggedIn
}

export default useUserLoginStatus
